import { nonNullable } from 'lib/array/arrayUtils'

export function getTransferOfferLookup(
  transferOffers?: App.LoyaltyTransferOffers,
): {
  experienceIds: Array<string>
  ticketIds: Array<string>
  experienceToTicketId: Map<string, string>
} {
  const offers = getConfiguredTransferOffers(transferOffers)
  const experienceToTicketId = mapExperienceToTicketId(offers)

  return {
    experienceIds: Array.from(experienceToTicketId.keys()),
    ticketIds: Array.from(experienceToTicketId.values()),
    experienceToTicketId,
  }
}

export function getConfiguredTransferOffers(
  transferOffers?: App.LoyaltyTransferOffers,
): Array<App.LoyaltyTransferOffer> {
  return nonNullable([
    transferOffers?.ultraLux,
    transferOffers?.loyaltyHomeToAirport,
  ])
}

export function hasConfiguredHomeToAirportOption(config?: App.LoyaltyConfig): boolean {
  const offer = config?.transferOffers?.loyaltyHomeToAirport

  return !!config?.homeToAirportEnabled &&
    !!offer?.experienceId &&
    !!offer?.ticketId
}

export function isConfiguredTransferExperienceItem(
  item: App.OrderExperienceItem,
  transferOffers?: App.LoyaltyTransferOffers,
): boolean {
  const { experienceToTicketId } = getTransferOfferLookup(transferOffers)

  return experienceToTicketId.get(item.experienceId) === item.ticket.id
}

function mapExperienceToTicketId(offers?: Array<App.LoyaltyTransferOffer>): Map<string, string> {
  return new Map(offers?.map((offer) => [offer.experienceId, offer.ticketId]) ?? [])
}
